var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { EventEmitter, OnInit } from '@angular/core';
import { Question } from '../../../core/models/question/question';
import { Answer } from '../../../core/models/answer/answer';
import { Assignment } from '../../../core/models/assignment/assignment';
import { FormControl } from '@angular/forms';
import { DialogService } from '../../../core/dialog/dialog.service';
var GroupQuestionComponent = /** @class */ (function () {
    function GroupQuestionComponent(dialog) {
        this.dialog = dialog;
        this.parentAnswerCreate = new EventEmitter();
        this.parentAnswerDelete = new EventEmitter();
        this.childAnswerChange = new EventEmitter();
        this.pictureAdd = new EventEmitter();
        this.pictureOpen = new EventEmitter();
        this.pictureDelete = new EventEmitter();
        this.pictureEdit = new EventEmitter();
        this.focus = new EventEmitter();
        this.selectedTab = new FormControl(0);
    }
    GroupQuestionComponent.prototype.ngOnInit = function () {
        this.focus.emit(this.question);
    };
    GroupQuestionComponent.prototype.addParentAnswer = function () {
        var newAnswer = new Answer({});
        newAnswer.questionId = this.question.id;
        newAnswer.assignmentId = this.assignment.id;
        this.question.groupAnswers.push(newAnswer);
        this.selectedTab.setValue(this.question.groupAnswers.length - 1);
        this.parentAnswerCreate.emit(newAnswer);
    };
    GroupQuestionComponent.prototype.deleteParentAnswer = function () {
        return __awaiter(this, void 0, void 0, function () {
            var confirm;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.dialog.confirmDialog('Confermi l\'eliminazione della riga?').toPromise()];
                    case 1:
                        confirm = _a.sent();
                        if (confirm) {
                            this.parentAnswerDelete.emit(this.question.groupAnswers[this.selectedTab.value]);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    GroupQuestionComponent.prototype.getChildAnswer = function (question, parentAnswer) {
        if (!parentAnswer || !parentAnswer.childAnswers) {
            return null;
        }
        return parentAnswer.childAnswers.find(function (childAnswer) { return childAnswer.questionId === question.id; });
    };
    GroupQuestionComponent.prototype.onAnswerChange = function (event, parentAnswer) {
        event.changes.parentAnswerId = this.question.groupAnswers[this.selectedTab.value].id;
        this.childAnswerChange.emit({
            changes: event.changes,
            parentAnswer: parentAnswer
        });
    };
    GroupQuestionComponent.prototype.onPictureAdd = function (pictureData, question, parentAnswer) {
        this.pictureAdd.emit({
            pictureData: pictureData,
            question: question,
            parentAnswer: parentAnswer
        });
    };
    GroupQuestionComponent.prototype.onPictureOpen = function (picture) {
        this.pictureOpen.emit(picture);
    };
    GroupQuestionComponent.prototype.onPictureDelete = function (event) {
        this.pictureDelete.emit(event);
    };
    GroupQuestionComponent.prototype.onPictureEdit = function (event) {
        this.pictureEdit.emit(event);
    };
    GroupQuestionComponent.prototype.questionTrackBy = function (index, item) {
        return item.id;
    };
    return GroupQuestionComponent;
}());
export { GroupQuestionComponent };
